import React from 'react';

const PROTECTED_ABBREVIATIONS = new Set([
  'dr', 'mr', 'mrs', 'ms', 'prof', 'sr', 'jr', 'e.g', 'i.e', 'etc', 'vs', 'no',
]);

const isProtectedPeriod = (textBeforePeriod) => {
  const tail = String(textBeforePeriod).trimEnd();
  const token = tail.match(/([A-Za-z]+(?:\.[A-Za-z]+)*)$/)?.[1]?.toLowerCase();
  if (token && PROTECTED_ABBREVIATIONS.has(token)) return true;
  // A., A.B., R.K., U.S., and similar initials/acronyms.
  return /(?:^|\s)(?:[A-Z]\.)*[A-Z]$/.test(tail);
};

export const splitReportSentences = (value) => {
  const text = String(value ?? '');
  const parts = [];
  const boundary = /\.(\s+)(?=(?:["'“”‘’(\[]*)[A-Z])/g;
  let start = 0;
  let match;
  while ((match = boundary.exec(text)) !== null) {
    if (isProtectedPeriod(text.slice(0, match.index))) continue;
    parts.push(text.slice(start, match.index + 1));
    start = match.index + 1 + match[1].length;
  }
  parts.push(text.slice(start));
  return parts;
};

// Retained as a compatibility boundary for all report renderers. Ordinary
// sentences must remain in their source paragraph: only the source's explicit
// list/numbering determines point ownership and line structure.
export const formatReportSentenceHtml = (html) => html || '';

export const SentenceLineFormatter = ({ text }) => {
  return <>{String(text ?? '')}</>;
};
